import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconSyncModule, MedIconXModule } from "@mk/med-icons";

import { MedBubbleComponent } from "./med-bubble.component";

@NgModule({
  declarations: [
    MedBubbleComponent,
  ],
  imports: [
    CommonModule,
    MedIconXModule,
    MedIconSyncModule,
  ],
  exports: [
    MedBubbleComponent,
  ],
})
export class MedBubbleModule { }
